import { logUserAction, SurfaceActionItem } from 'owa-surface-actions';

import { ComposeActionKey } from 'owa-outlook-service-option-store';
export const logCSAUserAction = (
    action: ComposeActionKey,
    item: SurfaceActionItem,
    suffix: string = ''
) => {
    logUserAction(true /* isCompose */, `${action}${suffix}`, item);
};
